import { authorizedFetch, API_ORIGIN } from '@yeshuman/sdk'
import { useQuery } from '@tanstack/react-query'

export type ProficiencyMix = {
  Foundational: number
  Working: number
  Advanced: number
  Expert: number
}

export type RecencyMix = {
  Current: number
  Recent: number
  'Not recent': number
  Undated: number
}

export type PoolCoverageDomain = {
  id: string
  key: string
  label: string
  skill_count: number
  candidate_count: number
}

export type PoolCoverageSkill = {
  id: string
  name: string
  candidate_count: number
  pool_rank: number
  proficiency_mix: ProficiencyMix
  experience_months: number
}

export type PoolCoverageLongTail = {
  id: string
  name: string
  candidate_count: number
}

export type PoolCoverageReport = {
  empty_catalog: boolean
  empty_pool: boolean
  message: string
  profile_count: number
  covered_profile_count: number
  uncovered_profile_count: number
  coverage_ratio: number
  published_skills: number
  possessed_published_skills: number
  catalog_use_ratio: number
  concentration_ratio: number
  depth_ratio: number
  recency_mix: RecencyMix
  proficiency_mix: ProficiencyMix
  domains: PoolCoverageDomain[]
  most_represented: PoolCoverageSkill[]
  most_experience: PoolCoverageSkill[]
  long_tail: PoolCoverageLongTail[]
}

export function useSkillPoolCoverage() {
  return useQuery({
    queryKey: ['skills', 'pool-coverage'],
    queryFn: async (): Promise<PoolCoverageReport> => {
      const response = await authorizedFetch(`${API_ORIGIN}/api/skills/pool-coverage`)
      const body = await response.json()
      if (!response.ok) {
        const error = new Error(
          (body as { error?: string; detail?: string }).error
            || (body as { detail?: string }).detail
            || `Failed to load pool coverage (${response.status})`,
        )
        ;(error as Error & { status?: number }).status = response.status
        throw error
      }
      return body as PoolCoverageReport
    },
  })
}
